'use client';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import PublicNav from '@/components/PublicNav';
import PublicFooter from '@/components/PublicFooter';
import HeroSection from './components/HeroSection';
import CourseHighlights from './components/CourseHighlights';
import FacilitiesSection from './components/FacilitiesSection';
import CorporateSection from './components/CorporateSection';
import PricingSection from './components/PricingSection';
import NewsSection from './components/NewsSection';
import TestimonialsSection from './components/TestimonialsSection';
import LoyaltyTeaser from './components/LoyaltyTeaser';
import UpcomingEvents from './components/UpcomingEvents';
import BookingCTA from './components/BookingCTA';
import Icon from '@/components/ui/AppIcon';
import MembershipBenefits from './components/MembershipBenefits';
import BookingProcess from './components/BookingProcess';

function AccessDeniedBanner() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <div className="bg-red-50 border-b border-red-200 px-4 py-3">
      <div className="max-w-screen-2xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 text-sm text-red-700">
          <Icon name="ExclamationCircleIcon" size={18} variant="outline" className="shrink-0" />
          <span>
            <strong>Access Restricted:</strong> Your account does not have permission to access the administration dashboard.
          </span>
        </div>
        <button
          onClick={() => setVisible(false)}
          className="text-red-400 hover:text-red-600 transition-colors shrink-0"
          aria-label="Dismiss"
        >
          <Icon name="XMarkIcon" size={18} variant="outline" />
        </button>
      </div>
    </div>
  );
}

function HomeContent() {
  const searchParams = useSearchParams();
  const accessDenied = searchParams?.get('access_denied') === '1';

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <PublicNav />
      {accessDenied && <AccessDeniedBanner />}
      <main className="flex-1">
        <HeroSection />
        <CourseHighlights />
        <BookingProcess />
        <div id="facilities">
          <FacilitiesSection />
        </div>
        <div id="membership">
          <MembershipBenefits />
        </div>
        <PricingSection />
        <CorporateSection />
        <LoyaltyTeaser />
        <UpcomingEvents />
        <NewsSection />
        <TestimonialsSection />
        <BookingCTA />
      </main>
      <PublicFooter />
    </div>
  );
}

export default function HomePage() {
  return (
    <React.Suspense fallback={
      <div className="flex flex-col min-h-screen bg-background">
        <PublicNav />
        <main className="flex-1">
          <HeroSection />
          <CourseHighlights />
          <div id="facilities"><FacilitiesSection /></div>
          <PricingSection />
          <CorporateSection />
          <LoyaltyTeaser />
          <UpcomingEvents />
          <NewsSection />
          <TestimonialsSection />
          <BookingCTA />
        </main>
        <PublicFooter />
      </div>
    }>
      <HomeContent />
    </React.Suspense>
  );
}